import orderBy from 'lodash/fp/orderBy';
import { AvailableDocumentDto } from '../../interfaces/Dto/AvailableDocumentDto';
import { AvailableDocumentGroup } from '../../interfaces/AvailableDocumentGroup';
import transformAvailableDocuments from './transformAvailableDocuments';

export default function groupAvailableDocuments(dtos: AvailableDocumentDto[]): AvailableDocumentGroup[] {
  const items: AvailableDocumentGroup[] = (dtos ?? []).map((dto: AvailableDocumentDto) => ({
    type: dto.name,
    documents: transformAvailableDocuments(dto.documentDefinitions),
  })).filter((g) => g.documents.length > 0);
  return orderBy((g: AvailableDocumentGroup) => g.type, 'asc')(items);
}
